import FloatingRate from "./FloatingRate";
import FixedRate from "./FixedRate";
class Coupon {
    firstCouponDate;
    floatingRate;
    fixedRate;
    interestBasis;
    constructor(response) {
        this.firstCouponDate = response.firstCouponDate;
        this.floatingRate = response.floatingRate !== undefined ? new FloatingRate(response.floatingRate) : undefined;
        this.fixedRate = response.fixedRate !== undefined ? new FixedRate(response.fixedRate) : undefined;
        this.interestBasis = response.interestBasis;
    }
    print() {
        if (this.fixedRate !== undefined) {
            return this.fixedRate.print();
        }
        if (this.floatingRate !== undefined) {
            return this.floatingRate.print();
        }
        return undefined;
    }
    printInterestBasis() {
        if (this.interestBasis !== undefined) {
            return this.interestBasis;
        }
        else if (this.fixedRate !== undefined) {
            return 'FIXED';
        }
        else if (this.floatingRate !== undefined) {
            return 'FLOATING';
        }
    }
}
export default Coupon;
